module.exports = __webpack_public_path__ + "img/tongguo.56e8c0b4.png";